import { useInfiniteQuery } from '@tanstack/react-query';
import { clientApi } from '../../configuration';

interface UsePathsInBulkParams {
  pathIds: number[];
}

const usePathsInBulk = ({ pathIds }: UsePathsInBulkParams) => {
  const pathRequest = useInfiniteQuery(
    ['pathsInBulk', pathIds],
    async ({
      pageParam = 19,
    }): Promise<{ totalEntities: number; rangeEnd: number; entities: any[] }> => {
      const { body: entities, pagination: responsePagination } = await clientApi
        .getOCClient()
        .helpers.learningContent.paths.find({
          ids: pathIds.join(','),
          start: pageParam - 19,
          end: pageParam,
        });

      const totalEntities = responsePagination
        ? responsePagination.totalElements
        : entities?.length;

      return {
        entities,
        totalEntities,
        rangeEnd: pageParam,
      };
    },
    {
      retry: 1,
      refetchOnWindowFocus: false,
      getNextPageParam: ({ rangeEnd, totalEntities }) =>
        rangeEnd + 1 >= totalEntities ? undefined : rangeEnd + 20,
    }
  );

  if (pathRequest.hasNextPage && !pathRequest.isFetchingNextPage) {
    pathRequest.fetchNextPage();
  }

  const { data, ...queryResult } = pathRequest;

  return {
    ...queryResult,
    data: data?.pages,
  };
};

export default usePathsInBulk;
